import React from 'react';

import { BrowserRouter as Router } from "react-router-dom";

import Nav from './nav';
import Body from './body';
import Footer from './footer';
import Authentication from './authentication'
import './styles/app.css';
import firebase, { auth, provider } from './firebase/firebase.js';


export default class App extends React.Component {
    constructor()
    {
      super();
      this.state =
      {
        user:null
      }
      this.login = this.login.bind(this);
      this.logout = this.logout.bind(this);

    }
    logout() {
        auth.signOut()
        .then(() => {
          this.setState({
            user: null
          });
        });      }
      login() {
        auth.signInWithPopup(provider) 
          .then((result) => {
            const user = result.user;
            this.setState({
              user
            });
          });
      }

      componentDidMount(){
        auth.onAuthStateChanged((user) => {
            if (user) {
              this.setState({ user });
            } 
          });
      }
  render() {
      return (
          <div className="layout">
              <Router>
                  <Nav AuthState = {this.state} AuthLogin={this.login} AuthLogout={this.logout}/>
                  <Body  AuthState = {this.state}/>
                  <Footer />
              </Router>
          </div>
      );
  }
};
